import { FC, ReactNode, useState } from 'react'
import { CheckIcon, CopyIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

/** 轻量 JSON 代码块:正则分词着色(替代 shiki,零额外体积),带复制按钮。 */

const TOKEN_RE =
  /("(?:\\.|[^"\\])*")|(-?\d+\.?\d*(?:[eE][+-]?\d+)?)|(\btrue\b|\bfalse\b|\bnull\b)/g

function highlightJson(code: string): ReactNode[] {
  const nodes: ReactNode[] = []
  let last = 0
  let m: RegExpExecArray | null
  let i = 0
  const re = new RegExp(TOKEN_RE)
  while ((m = re.exec(code)) !== null) {
    if (m.index > last) {
      nodes.push(<span key={i++} className="text-muted-foreground">{code.slice(last, m.index)}</span>)
    }
    const token = m[0]
    let cls = 'text-muted-foreground'
    if (m[1]) {
      // 字符串:后随冒号则是 key
      const rest = code.slice(m.index + token.length).match(/^\s*:/)
      cls = rest ? 'text-[#0451a5] font-medium' : 'text-[#067d17]'
    } else if (m[2]) {
      cls = 'text-[#d97706]'
    } else if (m[3]) {
      cls = 'text-[#7c3aed]'
    }
    nodes.push(<span key={i++} className={cls}>{token}</span>)
    last = m.index + token.length
  }
  if (last < code.length) {
    nodes.push(<span key={i++} className="text-muted-foreground">{code.slice(last)}</span>)
  }
  return nodes
}

export const JsonCode: FC<{ code: string; className?: string; maxHeight?: number }> = ({
  code,
  className,
  maxHeight = 320,
}) => {
  const [copied, setCopied] = useState(false)

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      /* clipboard 不可用时静默 */
    }
  }

  return (
    <div className={cn('group/code relative rounded-md bg-muted/50 text-xs', className)}>
      <button
        type="button"
        onClick={onCopy}
        className="absolute right-2 top-2 z-10 rounded-md p-1 text-muted-foreground opacity-0 transition-opacity hover:bg-muted hover:text-foreground group-hover/code:opacity-100"
        aria-label="复制"
      >
        {copied ? <CheckIcon className="size-3.5 text-green-600" /> : <CopyIcon className="size-3.5" />}
      </button>
      <pre
        className="overflow-auto p-3 pr-9 font-mono leading-relaxed whitespace-pre-wrap break-all"
        style={{ maxHeight }}
      >
        {highlightJson(code)}
      </pre>
    </div>
  )
}
